"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _reactPhoneNumberInput = _interopRequireDefault(require("react-phone-number-input"));

require("react-phone-number-input/bundle/style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  var input = props.input,
      label = props.label,
      _props$country = props.country,
      country = _props$country === void 0 ? 'US' : _props$country,
      meta = props.meta;

  var _ref = meta || {},
      touched = _ref.touched,
      error = _ref.error;

  var name = input.name;
  var hasError = touched && error;
  var className = props.className;
  var classes = ['curb-input', 'curb-form-element', 'curb-phone-input', "input-".concat(name)];

  if (className) {
    classes.push(className);
  }

  if (hasError) {
    classes.push('error');
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' ')
  }, label && /*#__PURE__*/_react.default.createElement("label", null, label), /*#__PURE__*/_react.default.createElement(_reactPhoneNumberInput.default, _extends({
    country: country
  }, input)), hasError && /*#__PURE__*/_react.default.createElement("span", {
    className: "error-msg"
  }, error));
}

;